@let createdOn = $safeNavigationMigration(examination?.createdOn);
@let createdBy = $safeNavigationMigration(examination?.createdByInstance);
@let updatedOn = $safeNavigationMigration(examination?.updatedOn);
@let updatedBy = $safeNavigationMigration(examination?.updatedByInstance);

<ng-container *transloco="let t">
  <p class="line-clamp-2 pt-2 text-center text-xs text-text-tertiary" data-testid="infos">
    @if (createdOn?.getTime() !== updatedOn?.getTime()) {
      <span [tuiHint]="creatorDetails">
        {{t('Modifié le {{ date }} à {{ time }} par {{ username }}', { date: updatedOn | date: 'mediumDate', time:
        updatedOn | date: 'shortTime', username: updatedBy | userName })}}
      </span>
    } @else {
      <ng-container *ngTemplateOutlet="creatorDetails" />
    }
  </p>

  <ng-template #creatorDetails>
    {{t('Créé le {{ date }} à {{ time }} par {{ username }}', { date: createdOn | date: 'mediumDate', time: createdOn |
    date: 'shortTime', username: createdBy | userName })}}
  </ng-template>
</ng-container>
